import { Link } from "react-router-dom";
import { Brand } from "@championcare/ui";

// Confirmation shown after a password-reset request.
export function CheckEmail() {
  return (
    <div className="pt-auth">
      <div className="pt-auth__card" style={{ textAlign: "center" }}>
        <div className="pt-auth__brand">
          <Brand size={28} />
        </div>
        <div
          aria-hidden
          style={{
            width: 56,
            height: 56,
            borderRadius: "50%",
            background: "var(--blush)",
            color: "var(--red)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 auto 16px",
          }}
        >
          <svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <rect x="2" y="4" width="20" height="16" rx="2" />
            <path d="M22 6l-10 7L2 6" />
          </svg>
        </div>
        <h1 className="pt-auth__title">
          Check your <em>email.</em>
        </h1>
        <p className="pt-auth__lede">
          If an account exists for that address, we&rsquo;ve sent a reset link. It expires in 30
          minutes — check your spam folder if you don&rsquo;t see it.
        </p>
        <Link to="/sign-in" className="pt-btn pt-btn--primary pt-auth__submit" style={{ display: "inline-flex" }}>
          Back to sign in
        </Link>
        <p className="pt-auth__note">Dev environment — no email is actually sent.</p>
      </div>
    </div>
  );
}
